import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPwaManifest } from '../utils/pwaManifest';

/**
 * Fait suivre le `<link rel="manifest">` à la page ouverte, pour que « Sur
 * l'écran d'accueil » installe la bonne application (boutique, caisse ou
 * accueil équipe). Ne rend rien. Voir `utils/pwaManifest.ts`.
 */
export default function PwaManifestSwitch() {
  const { pathname } = useLocation();
  useEffect(() => {
    applyPwaManifest(pathname);
  }, [pathname]);
  return null;
}
